import { render } from "./el-company-list.vue?vue&type=template&id=80e90d38"
import script from "./el-company-list.vue?vue&type=script&lang=ts"
export * from "./el-company-list.vue?vue&type=script&lang=ts"

import "./el-company-list.vue?vue&type=style&index=0&id=80e90d38&lang=less"
script.render = render

export default script